import { createSelector } from 'reselect'
import { selectMailboxesById } from 'selectors/mailboxes_base'
import { selectCurrentTicketUndecorated } from './current'

export const selectCurrentTicketMailboxId = createSelector(
  selectCurrentTicketUndecorated,
  ticket => (ticket ? ticket.mailboxId : null)
)

export const selectCurrentTicketMailbox = createSelector(
  selectCurrentTicketUndecorated,
  selectMailboxesById,
  (ticket, mailboxes) => {
    if (!ticket || !mailboxes) return null
    return mailboxes[ticket.mailboxId]
  }
)

export const selectCurrentTicketMailboxName = createSelector(
  selectCurrentTicketMailbox,
  currentMailbox => {
    return (currentMailbox && currentMailbox.name) || null
  }
)

export const selectCurrentTicketMailboxColor = createSelector(
  selectCurrentTicketMailbox,
  currentMailbox => {
    return (currentMailbox && currentMailbox.color) || null
  }
)
